import ScreeningDetails from './ScreeningDetails';

export default ScreeningDetails;
